import { BaseCustomerSurveyClient, User } from "@core/types";

class CustomerSurveyClient extends BaseCustomerSurveyClient {
  async getCustomerSurveyAnswers(userPhone: User["phone"]): Promise<never> {
    throw new Error("getCustomerSurveyAnswers not implemented");
  }

  async createCustomerSurveyAnswers(): Promise<void> {
    throw new Error("createCustomerSurveyAnswers not implemented");
  }
}

export default CustomerSurveyClient;
